import React from "react";
import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import ChimneyQuoteForm from "./sections/ChimneyQuoteForm";
import { Link } from "@/components/common/Link";
import { Brush, BrickWall, ShieldCheck, Construction, Search, Fan } from "lucide-react";
const chimneySubServices = [{
  title: "Chimney Repointing & Mortar Repair",
  description: "Expert mortar raking and precision repointing to prevent water ingress and restore the structural strength of your chimney stack in Southampton.",
  icon: BrickWall
}, {
  title: "Lead Flashing & Weatherproofing",
  description: <>
        High-grade milled{" "}
        <Link to="/LeadWorkPage" className="text-primary underline underline-offset-4 hover:text-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-sm">
          lead flashing
        </Link>{" "}
        installation, step flashing, and repairs to ensure an entirely watertight junction between your roof and chimney.
      </>,
  icon: ShieldCheck
}, {
  title: "Chimney Rebuilds & Restoration",
  description: "Complete or partial chimney reconstruction services using matching bricks and lime mortars to preserve character homes across Hampshire.",
  icon: Construction
}, {
  title: "Chimney Flaunching & Pot Resetting",
  description: "Durable sand-and-cement crown flaunching and secure chimney pot refitting to stop water penetration and secure loose terminal pots.",
  icon: Brush
}, {
  title: "Chimney Inspections & Surveys",
  description: "Thorough roof-level safety assessments to identify hidden cracks, damp spots, loose brickwork, or deteriorating flaunching before damage spreads.",
  icon: Search
}, {
  title: "Cowl, Cap & Bird Guard Installation",
  description: "Supply and fitting of quality chimney cowls, pepper pots, and stainless guards to stop downdraughts, rain entry, and nesting birds.",
  icon: Fan
}];
const introParagraphs = [<p key="p1">
    From targeted repointing and{" "}
    <Link to="/LeadWorkPage" className="text-primary underline underline-offset-4 hover:text-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-sm">
      lead flashing
    </Link>{" "}
    repairs to chimney flaunching and complete stack rebuilds, our local roofers in Southampton deliver lasting weather protection for your home.
  </p>, <p key="p2">
    We provide meticulous chimney repairs and maintenance to stop water ingress and masonry deterioration, serving Southampton, Hampshire &amp; surrounding areas.
  </p>];
const introBenefits = ["Expert chimney repairs, repointing, flaunching and lead flashing", "Prevents water ingress, damp ceilings and masonry deterioration", "Dedicated local roofing and chimney specialists led by Matt"];
export default function ChimneysPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <PageHero breadcrumbLabel="Chimneys" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Chimney Repairs in Southampton" intro="Expert chimney maintenance, repointing, lead flashing, and structural rebuilds to protect your home from damp and weather damage." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/professional_chimney_repair_uk.png" imageAlt="Chimney repairs and lead flashing work in Southampton" actions />
      <ServiceIntro eyebrow="EXPERT OVERVIEW" heading="Professional Chimney Repairs & Rebuilds in Southampton" paragraphs={introParagraphs} benefits={introBenefits} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/professional_chimney_repair_uk.png" imageAlt="Professional chimney repair and repointing in Southampton" cta />
      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our Chimney Repair & Maintenance Services" intro="Specialist chimney solutions designed to keep Southampton properties structurally sound, dry, and shielded from harsh coastal weather." items={chimneySubServices} columns={3} />
      <ServiceQuoteSection id="get-a-free-quote" eyebrow="GET A FREE QUOTE" heading="Get Your Free Southampton Chimney Quote Today" intro="Contact our skilled roofers today for a no-obligation quote on chimney repairs, lead flashing, or complete stack restoration in Southampton." serviceName="Chimneys">
        <ChimneyQuoteForm />
      </ServiceQuoteSection>
      <OtherServices currentKey="chimneys" count={4} />
      <CtaBand />
      <Footer />
    </div>;
}